module.exports = __webpack_public_path__ + "static/media/Sybill Trelawney 1.236d944e.jpg";